import { Pipe, PipeTransform } from '@angular/core';
import { Office } from '../models/missingdata.model';

@Pipe({
  name: 'userOfficeFilter'
})
export class UserOfficeFilterPipe implements PipeTransform {

  transform(items: Office[], args?: any): any {
    if (args.hasOwnProperty('fkIdOffice') && typeof items !== 'undefined') {

      let filteredItems = items.filter(item => item.idOffice == args.fkIdOffice);

      if (filteredItems.length > 0) {
        return filteredItems[0].officeName;

      } else {
        return "Sin resultado";
      }
    }
    return "Sin resultado";
  }

}
